import { ArrowRight } from "lucide-react";
import { Reveal } from "../smart/Reveal";
import { STEPS, LINKS } from "../../data/arccaContent";

const Eyebrow = ({ children }) => (
  <p className="text-xs font-display font-bold uppercase tracking-[0.2em] text-arcca-dark">{children}</p>
);

/* ---------- Cum obții BRD-ISIC ---------- */
export const ArccaSteps = () => (
  <section id="cum-obtii" data-testid="arcca-steps" className="scroll-mt-16 bg-slate-50 py-16 lg:py-24">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="max-w-3xl">
        <Reveal><Eyebrow>Cum obții BRD-ISIC</Eyebrow></Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-arccaink text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
            BRD-ISIC, în câțiva pași.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-5 text-base md:text-lg text-slate-600 leading-relaxed">
            Aplici pentru BRD-ISIC, iar după emiterea cardului acesta este automat activ în sistemul de control
            acces Arcca. Nu trebuie să faci o asociere separată sau o activare manuală pentru a-l folosi la
            turnicheții compatibili.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {STEPS.map((step, i) => (
          <Reveal key={step.title} delay={i * 0.1}>
            <div data-testid={`step-${i}`} className="relative h-full rounded-3xl border border-slate-200 bg-white p-8">
              <span className="font-display text-5xl font-extrabold text-arcca/30">0{i + 1}</span>
              <h3 className="mt-3 font-display font-bold text-xl text-arccaink">{step.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-600">{step.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 rounded-3xl border border-slate-200 bg-white px-7 py-6">
          <p className="text-sm leading-relaxed text-slate-500 max-w-2xl">
            Dacă ai deja BRD-ISIC, urmărește informațiile comunicate de Arcca despre folosirea cardului existent
            în noul sistem de acces.
          </p>
          <a
            href={LINKS.brdIsic}
            data-testid="steps-cta"
            className="shrink-0 inline-flex items-center gap-2 rounded-full bg-arccaink px-6 py-3 text-sm font-display font-bold text-white hover:bg-black transition-colors"
          >
            Află mai multe despre BRD-ISIC <ArrowRight size={16} />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
